/**
 * UI 交互常量
 *
 * 定义动画延迟、Toast 持续时间、分页默认值等 UI 相关的魔法值
 */

// ==================== Toast 配置 ====================

/** Toast 提示持续时间（毫秒） */
export const TOAST_DURATION = {
  /** 默认持续时间 */
  DEFAULT: 3000,
  /** 成功提示持续时间 */
  SUCCESS: 3000,
  /** 错误提示持续时间（较长，方便用户阅读） */
  ERROR: 5000,
  /** 警告提示持续时间 */
  WARNING: 4000,
  /** 信息提示持续时间 */
  INFO: 3000
} as const

// ==================== 分页组件默认值 ====================

/** BasePagination 组件默认配置 */
export const PAGINATION_DEFAULTS = {
  /** 默认每页条数 */
  PAGE_SIZE: 10,
  /** 默认当前页码 */
  CURRENT_PAGE: 1,
  /** 可选页大小选项 */
  PAGE_SIZES: [10, 20, 50, 100] as const,
  /** 最大显示页码数 */
  MAX_PAGES: 5
} as const
